var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrev1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 41,
    viewBox: "0 0 80 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_165_21)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.414474 18.8828L11.8716 0.660555C12.143 0.227778 12.5002 0 12.8859 0H75.843C77.5288 0 79.0716 1.59444 79.7573 4.03167C80.2859 5.92222 79.9145 8.22278 78.843 9.49833L69.643 20.4772L78.843 31.5017C79.9145 32.7772 80.2859 35.0778 79.7573 36.9683C79.0716 39.4283 77.5288 41 75.843 41H12.8716C12.5002 41 12.1288 40.7722 11.8573 40.3394L0.414474 22.1172C0.143044 21.6844 0.000183105 21.115 0.000183105 20.5C0.000183105 19.885 0.157326 19.3156 0.414474 18.8828Z",
    fill: "#C9A662"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_165_21"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 41,
    fill: "white",
    transform: "matrix(-1 0 0 1 80 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrev1);
export default __webpack_public_path__ + "static/media/prev1.ec6e140f0aaac9059c251dc92cadd2eb.svg";
export { ForwardRef as ReactComponent };